import { experiments } from '@/utils/experiment/manifest';
import { useExperiment } from '@/utils/experiment/use-experiment';

export enum LoomOnboardingVariants {
	VARIANT_1 = 'variant-1',
	VARIANT_2 = 'variant-2',
	CONTROL = 'control',
}

// Decides whether to render the onboarding UI or the Control Provisioning UI
export const useLoomOnboardingExperiment = () => {
	const result = {
		isExperimentLoomOnboardingToWac: false,
		loomOnboardingToWacVariant: null,
	};

	const loomOnboardingExperiment = useExperiment(experiments.expLoomOnboardingOnWac);
	const enrolled = loomOnboardingExperiment.type === 'enrolled';
	if (!enrolled) {
		return result;
	}

	if (
		!(Object.values(LoomOnboardingVariants) as string[]).includes(loomOnboardingExperiment.value) ||
		loomOnboardingExperiment.value === LoomOnboardingVariants.CONTROL
	) {
		return result;
	}

	return {
		isExperimentLoomOnboardingToWac: true,
		loomOnboardingToWacVariant: loomOnboardingExperiment.value as LoomOnboardingVariants,
	};
};
